// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"CardsSwiper_swiperContainer__1rJXT","card":"CardsSwiper_card__1ZWan","active":"CardsSwiper_active__1_2-H"};